"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isBrowser = _interopRequireDefault(require("./is-browser"));

var _localStorage = _interopRequireDefault(require("./local-storage"));

var _userMedia = _interopRequireDefault(require("./user-media"));

var _default = {
  isBrowser: (0, _isBrowser["default"])(),
  localStorage: (0, _localStorage["default"])(),
  userMedia: (0, _userMedia["default"])()
};
exports["default"] = _default;